module.exports = __webpack_public_path__ + "img/add.94ac5ed9.svg";